import { useCallback } from "react";
import {
  EDIT_IMAGE_TOOL,
  EDIT_IMAGE_WITH_PROMPT_TOOL,
  EDIT_SHAPE_TOOL,
  EDIT_TEXT_TOOL,
} from "../../../../../../routes.ts";
import { useSelectedTool } from "../../../../hooks/useSelectedTool.ts";
import {
  ASSET_LAYER_TYPE,
  IMAGE_LAYER_TYPE,
  LINE_LAYER_TYPE,
  SHAPE_LAYER_TYPE,
  TEXT_LAYER_TYPE,
} from "../constants.ts";
import { designerCanvasStore } from "../stores/designerCanvasStore.ts";
import type { Layer } from "../types.ts";
import { getLayerTypes } from "../utils/layer.ts";

export const useSelectLayers = () => {
  const { setSelectedTool } = useSelectedTool();

  const selectLayers = useCallback(
    (layers: Layer[], active = true) => {
      designerCanvasStore.selectLayers(
        layers.map((it) => it.id),
        active,
      );
      const layerTypes = getLayerTypes(layers);
      if (layerTypes.length === 0 || layers.length > 1) return;
      switch (layerTypes[0]) {
        // XXX: We use string replacement with absolute route constants instead of relative navigation
        // to avoid coupling this hook to the current route structure and nesting level.
        // This approach makes the hook reusable across different contexts and future-proof against
        // route structure changes.
        // Example usage contexts:
        //  - From base edit route: `/workspaces/123/boards/456/edit`
        //  - From existing tool: `/workspaces/123/boards/456/edit/edit-text`
        case TEXT_LAYER_TYPE:
          setSelectedTool(EDIT_TEXT_TOOL);
          break;
        case IMAGE_LAYER_TYPE:
          setSelectedTool(EDIT_IMAGE_TOOL);
          break;
        case SHAPE_LAYER_TYPE:
        case LINE_LAYER_TYPE:
          setSelectedTool(EDIT_SHAPE_TOOL);
          break;
        case ASSET_LAYER_TYPE:
          // FIXME: Instead of redirecting to a default tool
          // we should redirect to the "edit-asset" tool
          // and leave the correspondign component decide
          // which tool to open by default.
          setSelectedTool(EDIT_IMAGE_WITH_PROMPT_TOOL);
          break;
      }
    },
    [setSelectedTool],
  );

  const deselectLayers = useCallback(() => {
    designerCanvasStore.deselectLayers();
  }, []);

  return { selectLayers, deselectLayers };
};
